/**
 * 导出表格组件
 * @description 导出表格组件
 * @author mll
 * @date 2020-2-25
 */
import React from 'react';
import PropTypes from 'prop-types';

import { component_tool, utils_tool } from '../../tool'
let {
    WizComponent,
    WizCard,
    WizAntdForm,
    WizUpload,
    WizButton,
    WizIcon,
    WizSpin
} = component_tool;
const { Item } = WizAntdForm
let { excelUtils } = utils_tool;

export default class ExportExcel extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {
            fileList: [],
            spinning: false,
            other: {}
        }
        this.itemCol = {
            wrapperCol: {
                xs: { span: 10, offset: 1 },
                sm: { span: 10, offset: 1 },
            },
            labelCol: {
                xs: { span: 5, offset: 0 },
                sm: { span: 5, offset: 0 },
            },
        }
    }

    /**
     * 介绍
     */
    _info = ({ title, text }) => {
        if (title && text) {
            return (
                <WizCard title={title} icon='0'>
                    {text}
                </WizCard>
            )
        }

    }

    /**
     * 提交
     */
    _submit = () => {
        let files = this.state.fileList
        let { other } = this.state
        let { submit, dataFun } = this.props;
        this.setState({
            spinning: true
        }, () => {
            excelUtils.importExcel(
                { target: { files } },
                (fileData) => {
                    this.setState({ spinning: false }, () => {
                        submit && submit(files[0], fileData, other)
                    })
                },
                { dataFun }
            )
        })
    }

    /**
     * 提交按钮
     */
    _submitBtn() {
        let { fileList } = this.state
        if (fileList && fileList.length) {
            return (
                <Item label={' '} colon={false} {...this.itemCol}>
                    <WizButton type='primary' onClick={this._submit}>导 入</WizButton>
                </Item>
            )
        }
    }

    /**
     * 上传
     */
    _upload = (upload = {}) => {
        const { fileList } = this.state;
        const props = {
            onRemove: file => {
                this.setState(state => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                    };
                });
            },
            beforeUpload: file => {
                this.setState(state => ({
                    fileList: [file],
                }));
                return false;
            },
            fileList,
            accept: ".xlsx, .xls",
        };
        return (
            <Item label={'选择文件'} {...this.itemCol}>
                <WizUpload {...props}{...upload}>
                    <WizButton><WizIcon type="upload" /> 选择文件</WizButton>
                </WizUpload>
            </Item>
        )
    }

    /**
     * 自定义的传入
     */
    _other = () => {
        let { other } = this.props;
        let r = [];
        other && other.forEach(o => {
            r.push(this._temp(o))
        });
        return r
    }
    /**
        * 获取其他参数
        */
    _getOtherProps = (key, value) => {
        let o = Object.assign({}, this.state.other)
        o[key] = value
        this.setState({
            other: o
        })
    }

    /**
     * 模版
     */
    _temp = (o = { label: '请传入名称' }) => {
        let { item, comp } = o
        let view = comp ? comp(this._getOtherProps) : null;
        return (
            <Item colon={false} {...this.itemCol} {...item}>
                {view}
            </Item>
        )
    }

    /**
     * 操作
     */
    _operate = ({ title, template, upload }) => {
        let { label, fileName, href, onClick } = template
        let _template = label && fileName && (href || onClick) ?
            <Item label={label} {...this.itemCol}>
                <a download={fileName} onClick={onClick} href={href}>{fileName}</a>
            </Item> : null
        return (
            <WizCard title={title || '操作'} icon='0'>
                {this._other()}
                {_template}
                {this._upload(upload)}
                {this._submitBtn()}
            </WizCard>
        )
    }

    render() {
        let { infoProps, operateProps, loading } = this.props;
        let { spinning } = this.state
        return (
            <WizSpin spinning={spinning || loading} tip='文件处理中'>
                {this._info(infoProps)}
                {this._operate(operateProps)}
            </WizSpin>
        )

    }
}

/**
 * 默认值
 */
ExportExcel.defaultProps = {
    infoProps: {},
    operateProps: {
        title: '',
        template: {
            label: '模版下载',
            fileName: '',
            href: '',
        },
        upload: {

        }
    },
    dataFun: [],
}

/**
 * props入参校验
 */
ExportExcel.propTypes = {
    /**
     * 上方提示内容的框框
     * title card标题
     * text card内容
     *
     */
    infoProps: PropTypes.object.isRequired,
    /**
     * 操作区域的参数
     */
    operateProps: PropTypes.object.isRequired,
    /**
     * 点击提交时，可以获取数据。提供两个参数（file ->file格式的文件，fileData -> json格式的文件内容）
     */
    submit: PropTypes.func.isRequired,
    /**
     * 自定义item
     */
    other: PropTypes.array,
    /**
     * 获取fileData数据的内容，默认[],返回sheet_to_json的数据
     * 可选项：
     * sheet_to_json converts a worksheet object to an array of JSON objects.
     * sheet_to_csv generates delimiter-separated-values output.
     * sheet_to_txt generates UTF16 formatted text.
     * sheet_to_html generates HTML output.
     * sheet_to_formulae generates a list of the formulae (with value fallbacks).
     *
     */
    dataFun: PropTypes.array,
    /**
     * 控制组件的loading状态 与 文件校验的loading同级
     */
    loading: PropTypes.bool

}

ExportExcel.defaultProps = {
    loading: false
}